export default __webpack_public_path__ + "mini-icon-add-new-app@2x.png";